import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

import {
  getWorkAreas,
  createWorkArea,
  getTasksByArea,
  createTask
} from "../api/workApi";

import {
  getChecklist,
  createChecklistItem,
  updateChecklistItem
} from "../api/workChecklistApi";

import ChecklistExecutionDrawer from "../components/ChecklistExecutionDrawer";

const WorkAreaWorkspace = () => {

  const { workId } = useParams();

  /* ================= STATE ================= */

  const [areas,setAreas]=useState([]);
  const [selectedArea,setSelectedArea]=useState(null);
  const [tasks,setTasks]=useState([]);

  const [selectedTask,setSelectedTask]=useState(null);

  const [checklist,setChecklist]=useState([]);
  const [drawerItem,setDrawerItem]=useState(null);

  const [newAreaName,setNewAreaName]=useState("");
  const [newTaskName,setNewTaskName]=useState("");
  const [newChecklist,setNewChecklist]=useState("");

  /* ================= LOAD AREAS ================= */

  useEffect(()=>{
    if(workId) loadAreas();
  },[workId]);

  const loadAreas=async()=>{
    const res=await getWorkAreas(workId);
    const data=res.data||[];
    setAreas(data);
    if(data.length) setSelectedArea(data[0]);
  };

  /* ================= LOAD TASKS ================= */

  useEffect(()=>{
    if(selectedArea?.WorkAreaID)
      loadTasks(selectedArea.WorkAreaID);
  },[selectedArea]);

  const loadTasks=async(areaId)=>{
    const res=await getTasksByArea(areaId);
    setTasks(res.data||[]);
  };

  /* ================= LOAD CHECKLIST ================= */

  const openChecklist=async(task)=>{
    setSelectedTask(task);

    const res=await getChecklist(task.TaskID);
    setChecklist(res.data||[]);
  };

  /* ================= CREATE ================= */

  const createArea=async()=>{
    if(!newAreaName.trim()) return;

    await createWorkArea({
      workId,
      areaName:newAreaName
    });

    setNewAreaName("");
    loadAreas();
  };

  const createTaskHandler=async()=>{
    if(!newTaskName.trim()) return;

    await createTask({
      workAreaId:selectedArea.WorkAreaID,
      taskTitle:newTaskName
    });

    setNewTaskName("");
    loadTasks(selectedArea.WorkAreaID);
  };

  const addChecklistItem=async()=>{

    if(!newChecklist.trim()) return;

    await createChecklistItem({
      taskId:selectedTask.TaskID,
      title:newChecklist
    });

    setNewChecklist("");
    openChecklist(selectedTask);
  };

  /* ================= UPDATE ================= */

  const updateChecklist=(id,field,value)=>{

    setChecklist(prev =>
      prev.map(i =>
        i.ChecklistItemID===id
          ? {...i,[field]:value}
          : i
      )
    );

    if(drawerItem?.ChecklistItemID===id){
      setDrawerItem(prev=>({...prev,[field]:value}));
    }
  };

  const handleSave=async(item)=>{
    await updateChecklistItem(item.ChecklistItemID,{
      status:item.Status,
      result:item.Result,
      observation:item.Observation
    });

    openChecklist(selectedTask);
  };

  const handleAttachment=(id,file)=>{
    if(!file) return;

    updateChecklist(id,"AttachmentName",file.name);
  };

  /* ================= UI ================= */

  return (
<div className="grid grid-cols-12 gap-6">

{/* ================= LEFT AREAS ================= */}
<div className="col-span-3 bg-white border rounded-xl p-5 space-y-4">

<h3 className="font-semibold">Work Areas</h3>

<div className="flex gap-2">
<input
value={newAreaName}
onChange={e=>setNewAreaName(e.target.value)}
placeholder="Add Work Area..."
className="border px-3 py-2 rounded w-full"
/>

<button
onClick={createArea}
className="bg-indigo-600 text-white px-4 rounded"
>
Add
</button>
</div>

{areas.map(area=>(
<button
key={area.WorkAreaID}
onClick={()=>setSelectedArea(area)}
className={`w-full text-left p-3 border rounded ${
selectedArea?.WorkAreaID===area.WorkAreaID
?"bg-indigo-50":""
}`}
>
{area.AreaName}
</button>
))}

</div>

{/* ================= TASKS ================= */}
<div className="col-span-3 bg-white border rounded-xl p-5">

<h3 className="font-semibold mb-4">
{selectedArea?.AreaName}
</h3>

<input
value={newTaskName}
onChange={e=>setNewTaskName(e.target.value)}
placeholder="Add Sub Area..."
className="border px-3 py-2 rounded w-full mb-3"
/>

<button
onClick={createTaskHandler}
className="bg-indigo-600 text-white px-4 py-2 rounded w-full"
>
Add
</button>

<div className="mt-4 space-y-2">
{tasks.map(task=>(
<div
key={task.TaskID}
className={`p-3 border rounded cursor-pointer ${
selectedTask?.TaskID===task.TaskID
?"bg-indigo-50":""
}`}
onClick={()=>openChecklist(task)}
>
{task.TaskTitle}
</div>
))}
</div>

</div>

{/* ================= CHECKLIST ================= */}
<div className="col-span-6 bg-white border rounded-xl p-6">

<h3 className="font-semibold mb-4">
{selectedTask?.TaskTitle || "Select Task"}
</h3>

{selectedTask && (
<>
<div className="flex gap-2 mb-4">
<input
value={newChecklist}
onChange={e=>setNewChecklist(e.target.value)}
placeholder="Add Checklist Item..."
className="border px-3 py-2 rounded w-full"
/>

<button
onClick={addChecklistItem}
className="bg-indigo-600 text-white px-4 rounded"
>
Add
</button>
</div>

<div className="space-y-2">
{checklist.map((item,index)=>(
<div
key={item.ChecklistItemID}
onClick={()=>setDrawerItem(item)}
className="border p-3 rounded cursor-pointer hover:bg-slate-50"
>
{index+1}. {item.Title}
</div>
))}
</div>
</>
)}

</div>

{/* ================= DRAWER ================= */}
<ChecklistExecutionDrawer
drawerItem={drawerItem}
setDrawerItem={setDrawerItem}
updateChecklist={updateChecklist}
handleSave={handleSave}
handleAttachment={handleAttachment}
/>

</div>
);
};

export default WorkAreaWorkspace;